import { Space } from 'antd';
import styled from 'styled-components';

export const StyledSpace = styled(Space)`
  & > .ant-space-item {
    flex: 1;
    .ant-typography {
      text-transform: capitalize;
    }
  }
`;
